export default __webpack_public_path__ + "static/media/svg.b4e1d776.svg";